import { z } from 'zod';

export const LegalAgreementSchema = () =>
  z.object({
    groupAgreement1: z.boolean().refine((value) => value === true),
    groupAgreement2: z.boolean().refine((value) => value === true),
    savingsAccountAgreement: z.boolean().optional(),
    agreeToAll: z.boolean().optional(),
  });
